import React from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { getFormFields, isFormValid, onEmailChange, onNumberChange, onTextChange } from 'src/Utils/formHelper';
import { Button } from 'primereact/button';
import { trimObj } from 'src/Utils';
import Service from 'src/Service';
import { saveUserSession } from './../store/actions'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Authentication from './../session/index'
import LoadingComponent from 'src/LoadingComponent';
import ServerlessService from 'src/Service/ServerlessService';


let formFields = [
    {
        "Type": "Number",
        "Label": "OTP",
        "FieldName": "otp",
        "Required": true,
        "MinLength": 6,
        "MaxLength": 6
    },
    {
        "Type": "Password",
        "Label": "Password",
        "FieldName": "password",
        "Required": true,
        "MinLength": 8
    },
    {
        "Type": "Password",
        "Label": "Confirm Password",
        "FieldName": "passwordConfirm",
        "Required": true,
        "MinLength": 8
    },

]




class VerifyOTPAchangeP extends React.Component {

    constructor(props) {
        super(props);
        this.formFields = getFormFields(formFields, {});
        this.state = {
            user: this.formFields.data,
            formValidations: this.formFields.formValidations,
            otpResentCount: 0
        }
        this.service = new Service();
        this.serverlessService = new ServerlessService();
    }



    isAdditionalValid = () => {

        let user = JSON.parse(JSON.stringify(this.state.user));
        let { formValidations } = this.state;
        // password and confirm password 
        let isValid = true;
        if (user.password != user.passwordConfirm) {
            isValid = false;
            formValidations.fields['passwordConfirm'] = { ...formValidations.fields['passwordConfirm'], isValid: false, errorMsg: `Password and Confirm password is not matched.` }
        }

        this.setState((prevState) => {
            return {
                formValidations
            };
        });

        return isValid

    }


    onVerify = () => {
        let { user } = this.state;

        const formStatus = isFormValid(formFields, this.formFields.formValidations, trimObj(this.state.user));


        let isCompleteFormValid = true;
        if (!formStatus.formValidations.isFormValid) {
            this.setState({
                formValidations: formStatus.formValidations,
            });
            isCompleteFormValid = false;
        }


        if (!this.isAdditionalValid()) {
            isCompleteFormValid = false;
        }

        if (isCompleteFormValid) {
            let data = trimObj(this.state.user);
            //  delete data.passwordConfirm;
            data._id = this.props.userId;

            this.setState({
                isLoading: true
            });

            const url = `/admin/verify-change`;

            this.serverlessService.post(url, data, true).then((res) => {
                if (res && res.status && res.res.status) {
                    this.setState({
                        isLoading: false
                    }, () => {
                        this.props.saveUserSession(res.res);
                        this.props.history.push('/')
                    })
                } else {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Error', detail: res.message, life: 3000 });
                }
            }).catch(e => {
                console.log(e);
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Some error occured', detail: e.message, life: 3000 });
            })



        } else {
            this.setState({
                otpErrMsg: 'Invalid OTP.'
            })


        }
    }

    resendOTP = () => {

        if (this.state.otpResentCount < 3) {



            this.setState({
                isLoading: true
            });

            const url = `/admin/resend-otp`;

            this.service.post(url, { _id: this.props.userId }, true).then((res) => {
                if (res && res.status && res.res.status) {

                    this.setState((prevState) => {
                        return {
                            isLoading: false,
                            otpResentCount: prevState.otpResentCount + 1
                        };
                    });
                    this.toast.show({ severity: 'success', summary: 'Success', detail: 'OTP sent successfully.', life: 3000 });
                } else {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Error', detail: res.message, life: 3000 });
                }
            }).catch(e => {
                console.log(e);
                this.setState({
                    isLoading: false
                });
                this.toast.show({ severity: 'error', summary: 'Some error occured', detail: e.message, life: 3000 });
            })
        } else {
            this.toast.show({ severity: 'error', summary: 'Error', detail: 'OTP resent limit exceeded, please try later.', life: 3000 });
        }
    }


    render() {
        //  console.log(this.props)
        const { formValidations, user } = this.state;
        return (<>
            <div className='doctor-login-form'>
                <div>
                    <p className='sp-label-s1 sp-mt10 sp-no-pm'>OTP<span className='sp-required'>*</span></p>
                    <InputText value={user.otp}
                        className='sp-w100p  p-inputtext-style1'
                        onChange={(e) => { onNumberChange(e.target.value, 'otp', this, formFields, user, formValidations, 'user', 'formValidations') }} />
                    {formValidations && !formValidations.fields['otp'].isValid && <p className="p-error">{formValidations.fields['otp'].errorMsg}</p>}
                    <p className='sp-label-s1 sp-mt10 sp-no-pm'>Password<span className='sp-required'>*</span></p>
                    <InputText value={user.password}
                        type="password"
                        autoComplete="new-password"
                        className='sp-w100p  p-inputtext-style1'
                        onChange={(e) => { onTextChange(e.target.value, 'password', this, formFields, user, formValidations, 'user', 'formValidations') }} />
                    {formValidations && !formValidations.fields['password'].isValid && <p className="p-error">{formValidations.fields['password'].errorMsg}</p>}
                    <p className='sp-label-s1 sp-mt10 sp-no-pm'>Confirm Password<span className='sp-required'>*</span></p>
                    <InputText value={user.passwordConfirm}
                        type="password"
                        autoComplete="new-password"
                        className='sp-w100p  p-inputtext-style1'
                        onChange={(e) => { onTextChange(e.target.value, 'passwordConfirm', this, formFields, user, formValidations, 'user', 'formValidations') }} />
                    {formValidations && !formValidations.fields['passwordConfirm'].isValid && <p className="p-error">{formValidations.fields['passwordConfirm'].errorMsg}</p>}

                    <Toolbar className="sp-toolbar sp-mt20"
                        right={() => {
                            return (<Button label='Change' className=''
                                onClick={this.onVerify}
                            />)
                        }}

                        left={() => {
                            return (<div>
                                <p>OTP not recieved? <span className='register-txt' onClick={this.resendOTP} >Resend</span></p>
                            </div>)
                        }}
                    ></Toolbar>
                </div>
            </div>
            <Toast ref={(el) => this.toast = el} position="bottom-right" />
            {
                this.state.isLoading && <>
                    <LoadingComponent />
                </>
            }

        </>)
    }
}


const mapStateToProps = (state) => ({
    user: state.user,
    userType: state?.user?.userType,
    authenticated: state?.user?.authenticated,
});


export default connect(mapStateToProps, {
    saveUserSession,
})(Authentication(withRouter(VerifyOTPAchangeP)));
